import React, { createContext, useContext, useState, useEffect } from 'react'
import AuthStore from './stores/AuthStore'
import { STUDENT, TUTOR } from './stores/UsersStore'

const LanguageContext = createContext()

export const LanguageProvider = ({ children }) => {
  const [locale, setLocale] = useState('pt-BR')
  const [isInitialized, setIsInitialized] = useState(false)

  // Verifica se o usuário é SOMENTE tutor OU SOMENTE student
  const isEligibleUser = () => {
    return AuthStore && AuthStore.roles && (
      (AuthStore.roles.includes(TUTOR) && AuthStore.roles.length === 1) ||
      (AuthStore.roles.includes(STUDENT) && AuthStore.roles.length === 1) ||
      (AuthStore.roles.includes(TUTOR) && AuthStore.roles.includes(STUDENT) && AuthStore.roles.length === 2)
    )
  }

  const changeLanguage = (lang) => {
    // Só permite mudar o idioma se o usuário for elegível
    if (!isEligibleUser()) {
      return
    }

    setLocale(lang)

    // Salva o idioma na sessão atual
    sessionStorage.setItem('userLocale', lang)
    localStorage.setItem('userLocale', lang)

    // Força atualização do tema ou qualquer outro componente que dependa do idioma
    window.dispatchEvent(new Event('localeChanged'))
  }

  useEffect(() => {
    // Função para carregar o idioma adequado
    const loadLanguage = () => {
      // Se o usuário não estiver autenticado ou não for elegível, usa o idioma padrão
      if (!AuthStore.is_authenticated || !isEligibleUser()) {
        setLocale('pt-BR')
        setIsInitialized(true)
        return
      }

      // Verifica se existe um idioma salvo na sessão atual
      const sessionLocale = sessionStorage.getItem('userLocale')
      const localLocale = localStorage.getItem('userLocale')

      if (sessionLocale || localLocale) {
        setLocale(sessionLocale || localLocale)
      }

      setIsInitialized(true)
    }

    // Carrega o idioma inicial
    loadLanguage()

    // Registra um listener para mudanças no estado de autenticação
    const handleAuthChange = () => {
      loadLanguage()
    }

    // Adiciona o listener para eventos de autenticação
    window.addEventListener('authStateChanged', handleAuthChange)
    window.addEventListener('profileChanged', handleAuthChange)

    // Registra um observer para o logout
    const originalLogout = AuthStore.logout
    AuthStore.logout = function (message = '') {
      // Remove as preferências de idioma do usuário atual
      if (AuthStore.user && AuthStore.user.id) {
        // Não removemos a preferência do usuário para que ele possa recuperá-la no próximo login
        // Apenas limpamos a sessão atual
        sessionStorage.removeItem('userLocale')
        localStorage.removeItem('userLocale')
      }

      // Chama a função original de logout
      return originalLogout.call(this, message)
    }

    return () => {
      // Restaura a função original de logout e remove os listeners
      if (typeof AuthStore.logout === 'function') {
        AuthStore.logout = originalLogout
      }
      window.removeEventListener('authStateChanged', handleAuthChange)
      window.removeEventListener('profileChanged', handleAuthChange)
    }
  }, [])

  return (
    <LanguageContext.Provider value={{ locale, changeLanguage, isInitialized }}>
      {children}
    </LanguageContext.Provider>
  )
}

export const useLanguage = () => useContext(LanguageContext)
